// import images from all-images/blog-img directory
import img01 from "../all-images/blog-img/blog-1.jpg";
import img02 from "../all-images/blog-img/blog-2.jpg";
import img03 from "../all-images/blog-img/blog-3.jpg";

const blogData = [
  {
    id: 1,
    title: "What to Consider When Importing a Car",
    author: "White Lions Legacies",
    date: "01 Jan, 2026",
    time: "10:00",
    imgUrl: img01,
    description:
      "Importing a car can be a great way to get the exact model you want. Start by deciding your budget, preferred make/model, and the key specifications. If you have a preferred color, include it in your request. At White Lions Legacies we source vehicles from the UK and South Africa and guide you through the process from enquiry to delivery.",
    quote:
      "If you know the model and color you want, we can help you source it and keep you updated throughout the process.",
  },

  {
    id: 2,
    title: "How to Choose the Right Car for Your Budget",
    author: "White Lions Legacies",
    date: "15 Jan, 2026",
    time: "10:00",
    imgUrl: img02,
    description:
      "Choosing a car is easier when you start with your main needs: daily commute, family use, business, or long-distance travel. Consider fuel type, maintenance costs, and whether you prefer automatic or manual transmission. If you are not sure, contact our team and we will recommend suitable options from our available stock or through import-to-order.",
    quote:
      "Tell us your budget and needs, and we will help you shortlist the right options.",
  },

  {
    id: 3,
    title: "Custom Orders: Choosing Color and Specifications",
    author: "White Lions Legacies",
    date: "01 Feb, 2026",
    time: "10:00",
    imgUrl: img03,
    description:
      "If you want a specific look and features, a custom order is a great option. Provide your preferred make/model, color, and key requirements such as trim level, fuel type, and transmission. Our team will help you source matching options from the UK or South Africa and advise you on next steps.",
    quote:
      "The more details you share (including color), the easier it is to source the right vehicle.",
  },
];

export default blogData;
